import { changeCommaToDot, getDefaultProduct, getProductsByType, getProdcutsByLanguage, 
  getMaterialStandard, getCalculation, getSection, translations, getUIText } from '../utils/index';

import { getItemByNid } from '../utils/calculations-helper';

import { INITIAL_STATE, SECTION_INITIAL_STATE, CALCULATION_PATCH, CALCULATION_PATCH_SECTION, CALCULATION_LAYER_POSITION, CALCULATION_CREATE, CALCULATION_CHANGE_TYPE, CALCULATION_TYPE_PLANE, CALCULATION_TYPE_PIPE, CALCULATION_TYPE_DUCT, CALCULATION_TYPE_TANK, CALCULATION_TYPE_CIRCULAR_DUCT, CALCULATION_TYPE_RECTANGULAR_DUCT, CALCULATION_TYPE_VERTICAL_TANK, CALCULATION_TYPE_HORIZONTAL_TANK, CALCULATION_TYPE_RECTANGULAR_TANK, CALCULATION_TYPE_MARINE, CALCULATION_TOP_LAYERS, CALCULATION_SIDE_LAYERS, CALCULATION_ADD_SECTION, CALCULATION_REMOVE_SECTION, CALCULATION_ADD_ADAPTER, CALCULATION_REMOVE_ADAPTER, CALCULATION_PATCH_ADAPTER, updateCalculation, patchCalculation, patchCalculationSection, calculateResults } from '../modules/calculation';


import { patchArchiveItem, getItemFromArchive } from '../modules/archive';

import { adobeClickInsulationObject } from '../utils/analytics';

function getDefaultEnvironment({environments}, {environmentType}) {
  let o = {};

  if(!environmentType && environments && environments.data) {
    let selectedEnvironment = environments.data[0];
    o.environmentType = selectedEnvironment ? selectedEnvironment.Nid : null,
    o.environmentTemperature = selectedEnvironment ? selectedEnvironment['Ambient-temperature'] : null,
    o.environmentAirVelocity = selectedEnvironment ? selectedEnvironment['Ambient-air-velocity'] : null,
    o.environmentHumidity = selectedEnvironment ? selectedEnvironment['Ambient-relative-humidity'] : null;
  }

  return o;
}

function getUpdatedEnvironment({environments, project}, {environmentType}) {
  let o = {};

  if(environmentType && environments && environments.data) {
    let selectedEnvironment = environments.data.find( item => {
      return item.Nid === environmentType;
    });

    if(selectedEnvironment) {
      o.environmentTemperature = selectedEnvironment['Ambient-temperature'];
      o.environmentAirVelocity = selectedEnvironment['Ambient-air-velocity'];
      o.environmentHumidity = selectedEnvironment['Ambient-relative-humidity'];
    }
  }
  return o;
}

function getDefaultEnergy({energy, settings}, {energyType}) {
  let o = {};

  if(!energyType && energy && energy.data) {
    const defaulEnergySource = settings ? settings['Default-energy-source'] : null;
    const selectedEnergyItem = energy.data.find( item => {
      return item.Nid === defaulEnergySource;
    });
    o.energyType = selectedEnergyItem ? selectedEnergyItem.Nid : '179';
  }
  return o;
}

function getDefaultMaterial({materials, settings}, {material}) {
  let o = {};

  if(!material && materials && materials.data) {
    const defaulMaterial = settings ? settings['Default-material'] : null;
    const selectedMaterialItem = materials.data.find( item => {
      return item.Nid === defaulMaterial;
    });
    o.material = selectedMaterialItem ? selectedMaterialItem.Nid : null;
  }
  return o;
}

function getDefaultContent({mediums, settings}, {content, type}) {
  let o = {};
  if(!content && mediums && mediums.data && type) {
    let defaulMediumType = 'Default-medium-pipe';
    if(type === CALCULATION_TYPE_PIPE) {
      defaulMediumType = 'Default-medium-pipe';
    } else if(type === CALCULATION_TYPE_CIRCULAR_DUCT || type === CALCULATION_TYPE_RECTANGULAR_DUCT) {
      defaulMediumType = 'Default-medium-duct';
    } else if(type === CALCULATION_TYPE_VERTICAL_TANK || type === CALCULATION_TYPE_HORIZONTAL_TANK || type === CALCULATION_TYPE_RECTANGULAR_TANK) {
      defaulMediumType = 'Default-medium-tank';
    }

    const defaulMedium = settings ? settings[defaulMediumType] : null;
    let selectedMediumItem = mediums.data.find( item => {
      return item.Nid === defaulMedium;
    });

    if(!selectedMediumItem) {
      selectedMediumItem = mediums.data[0];
    }

    o.content = selectedMediumItem ? selectedMediumItem.Nid : null;
    o.temperature = selectedMediumItem ? (selectedMediumItem.Temperature && selectedMediumItem.Temperature !== '') ? selectedMediumItem.Temperature : 100 : 100;
  }
  return o;
}

function getUpdatedContent({mediums, settings}, {content}) {
  let o = {};

  if(content && mediums && mediums.data) {
    const selectedMediumItem = mediums.data.find( item => {
      return item.Nid === content;
    });
    o.temperature = selectedMediumItem ? (selectedMediumItem.Temperature && selectedMediumItem.Temperature !== '') ? selectedMediumItem.Temperature : 100 : 100;
  }
  return o;
}

function getDefaultCladding({claddings}, {cladding}) {
  let o = {};

  if(!cladding && claddings && claddings.data) {
    /*
    let selectedCladding = claddings.data[0]
    o.cladding = selectedCladding ? selectedCladding.Nid : null
    o.emissivity = selectedCladding ? changeCommaToDot(selectedCladding.Emissivity) : null
    */
    o.cladding = -2;
  }

  return o;
}

function getUpdateEmissivity({claddings, project, products, materials}, {cladding, noInsulation, material, selectedLayers, emissivity, insulationLayers}) {
  let o = {};

  const c = getCalculation(project);
  const s = getSection(c);

  // Check if noInsulation is set. If it is, take emissity from material
  let tempSelectedLayers;
  if(selectedLayers !== undefined) {
    tempSelectedLayers = selectedLayers;
  } else {
    tempSelectedLayers = s.selectedLayers;
  }

  let tempNoInsulation = false;
  if(noInsulation !== undefined) {
    tempNoInsulation = noInsulation;
  } else {
    if(s.type != CALCULATION_TYPE_VERTICAL_TANK &&
      s.type != CALCULATION_TYPE_HORIZONTAL_TANK &&
      s.type != CALCULATION_TYPE_RECTANGULAR_TANK) {
      tempNoInsulation = s.noInsulation;
    } else {
      if(tempSelectedLayers === CALCULATION_TOP_LAYERS) {
        tempNoInsulation = s.topNoInsulation;
      } else if (tempSelectedLayers === CALCULATION_SIDE_LAYERS) {
        tempNoInsulation = s.sideNoInsulation;
      } else {
        tempNoInsulation = s.bottomNoInsulation;
      }
    }
  }

  // If no insulation is true => take emissivity from object
  if(tempNoInsulation) {
    let tempMaterial;
    if(material !== undefined) {
      tempMaterial = material;
    } else {
      tempMaterial = s.material;
    }

    if(materials && materials.data) {
      const selectedMaterial = getItemByNid(tempMaterial, materials);
      if(selectedMaterial && selectedMaterial['Emissivity']) {
        o.emissivity = changeCommaToDot(selectedMaterial['Emissivity']);
      }
    }
    return o;
  } else if (claddings && claddings.data) {
    let tempCladding;
    if(cladding !== undefined) {
      tempCladding = cladding;
    } else {
      tempCladding = s.cladding;
    }
    const selectedCladding = getItemByNid(tempCladding, claddings);
    if(selectedCladding) {
      // If cladding is true take emissivity from it
      if(selectedCladding['Emissivity']) {
        o.emissivity = changeCommaToDot(selectedCladding['Emissivity']);
      }
    } else if (tempCladding === -1) {
      // If cladding is "Other cladding", use emissivity value in state
      // TODO: need to test do this work like this...
    } else if (tempCladding === -2) {
      // If cladding is "No additional cladding", use top product
      let tempSelectedLayers;
      if(selectedLayers !== undefined) {
        tempSelectedLayers = selectedLayers;
      } else {
        tempSelectedLayers = s.selectedLayers;
      }
      let tempLayers;
      if(insulationLayers != undefined) {
        tempLayers = insulationLayers;
      } else {
        if(s.type != CALCULATION_TYPE_VERTICAL_TANK &&
          s.type != CALCULATION_TYPE_HORIZONTAL_TANK &&
          s.type != CALCULATION_TYPE_RECTANGULAR_TANK) {
          tempLayers = s.insulationLayers;
        } else {
          if(tempSelectedLayers === CALCULATION_TOP_LAYERS) {
            tempLayers = s.topInsulationLayers;
          } else if (tempSelectedLayers === CALCULATION_SIDE_LAYERS) {
            tempLayers = s.sideInsulationLayers;
          } else {
            tempLayers = s.bottomInsulationLayers;
          }
        }
      }

      if(tempLayers && tempLayers.length) {
        const topLayer = tempLayers[0];
        const topProduct = getItemByNid(topLayer.selectedItem, products);
        if(topProduct && topProduct['Emissivity']) {
          o.emissivity = changeCommaToDot(topProduct['Emissivity']);
        }
      }
    }
  }
  return o;
}

function checkIfSupportOfCladdingIsPossible({products, settings}, {insulationLayers}) {
  let o = {};

  if(insulationLayers) {
    for (var i = 0; i < insulationLayers.length; i++) {
      let item = insulationLayers[i];
      let product = getItemByNid(item.selectedItem, products);
      if(product && (product['Support-possible'] === 'true' || product['Support-possible'] === true)) {
        o.supportOfCladdingPossible = true;
      }
    }
    if(!o.supportOfCladdingPossible && settings) {
      o.supportOfCladdingPossible = false;
      o.supportOfCladding = false;
      // o.influenceOnHeatloss = settings['Default-support-value']
    }
  }

  return o;
}

function updateInsulationLayers({project}, {insulationLayers}) {
  let o = {};

  const c = getCalculation(project);
  const s = getSection(c);
  const {
    topInsulationLayers,
    sideInsulationLayers,
    bottomInsulationLayers,
    selectedLayers,
    type,
  } = s ? s : {};

  if(type != CALCULATION_TYPE_VERTICAL_TANK &&
    type != CALCULATION_TYPE_HORIZONTAL_TANK &&
    type != CALCULATION_TYPE_RECTANGULAR_TANK ) {
    return o;
  }

  if(insulationLayers && selectedLayers && topInsulationLayers && sideInsulationLayers && bottomInsulationLayers) {
    if(selectedLayers === CALCULATION_TOP_LAYERS) {
      o = {
        ...o,
        topInsulationLayers: insulationLayers.slice()
      };
    } else if(selectedLayers === CALCULATION_SIDE_LAYERS) {
      o = {
        ...o,
        sideInsulationLayers: insulationLayers.slice()
      };
    } else {
      o = {
        ...o,
        bottomInsulationLayers: insulationLayers.slice()
      };
    }
  }

  return o;
}

function setCladdingAndEmissivity({project}, {cladding, emissivity, selectedLayers}) {
  let o = {};

  // console.log(cladding, emissivity, selectedLayers);

  const c = getCalculation(project);
  const s = getSection(c);

  if(s.type != CALCULATION_TYPE_VERTICAL_TANK &&
    s.type != CALCULATION_TYPE_HORIZONTAL_TANK &&
    s.type != CALCULATION_TYPE_RECTANGULAR_TANK ) {
    return o;
  }

  const tempSelectedLayers = selectedLayers ? selectedLayers : s.selectedLayers;
  if(tempSelectedLayers) {
    if(tempSelectedLayers === CALCULATION_TOP_LAYERS) {
      if(cladding) {
        o = {
          ...o,
          topCladding: cladding,
        };
      }

      if(emissivity) {
        o = {
          ...o,
          topEmissivity: emissivity,
        };
      }
    } else if(tempSelectedLayers === CALCULATION_SIDE_LAYERS) {
      if(cladding) {
         o = {
          ...o,
          sideCladding: cladding,
        };
      }

      if(emissivity) {
         o = {
          ...o,
          sideEmissivity: emissivity
        };
      }
    } else {
      if(cladding) {
        o = {
          ...o,
          bottomCladding: cladding,
        };
      }

      if(emissivity) {
        o = {
          ...o,
          bottomEmissivity: emissivity
        };
      }
    }
  }

  return o;
}

function getCladdingAndEmissivity({project}, {selectedLayers}) {
  let o = {};

  const c = getCalculation(project);
  const s = getSection(c);

  const {
    topCladding,
    sideCladding,
    bottomCladding,
    topEmissivity,
    sideEmissivity,
    bottomEmissivity,
    type,
    } = s ? s : {};

  if(type != CALCULATION_TYPE_VERTICAL_TANK &&
    type != CALCULATION_TYPE_HORIZONTAL_TANK &&
    type != CALCULATION_TYPE_RECTANGULAR_TANK ) {
    return o;
  }

  if(selectedLayers) {
    if(selectedLayers === CALCULATION_TOP_LAYERS) {
      o = {
        ...o,
        cladding: topCladding,
        emissivity: topEmissivity
      };
    } else if(selectedLayers === CALCULATION_SIDE_LAYERS) {
      o = {
        ...o,
        cladding: sideCladding,
        emissivity: sideEmissivity
      };
    } else {
      o = {
        ...o,
        cladding: bottomCladding,
        emissivity: bottomEmissivity
      };
    }
  }

  return o;
}

function updateNoInsulation({project}, {noInsulation}) {
  let o = {
  };

  const c = getCalculation(project);
  const s = getSection(c);
  const {
    type,
    selectedLayers,
    } = s ? s : {};

  if(type === CALCULATION_TYPE_VERTICAL_TANK || type === CALCULATION_TYPE_HORIZONTAL_TANK || type === CALCULATION_TYPE_RECTANGULAR_TANK) {
    if(selectedLayers === CALCULATION_TOP_LAYERS) {
      o = {
        topNoInsulation: noInsulation
      };
    } else if(selectedLayers === CALCULATION_SIDE_LAYERS) {
      o = {
        sideNoInsulation: noInsulation
      };
    } else {
      o = {
        bottomNoInsulation: noInsulation
      };
    }
  }

  return o;
}

function setInsulationLayers({project}, {selectedLayers}) {
  let o = {};

  const c = getCalculation(project);
  const s = getSection(c);

  const {
    topInsulationLayers,
    sideInsulationLayers,
    bottomInsulationLayers,
    topNoInsulation,
    sideNoInsulation,
    bottomNoInsulation,
    topEmissivity,
    sideEmissivity,
    bottomEmissivity,
    topCladding,
    sideCladding,
    bottomCladding,
    } = s ? s : {};

  if(selectedLayers) {
    let items;
    if(selectedLayers === CALCULATION_TOP_LAYERS) {
      o.insulationLayers = topInsulationLayers.slice();
      o.noInsulation = topNoInsulation;
      o.emissivity = topEmissivity;
      o.cladding = topCladding;
    } else if(selectedLayers === CALCULATION_SIDE_LAYERS) {
      o.insulationLayers = sideInsulationLayers.slice();
      o.noInsulation = sideNoInsulation;
      o.emissivity = sideEmissivity;
      o.cladding = sideCladding;
    } else {
      o.insulationLayers = bottomInsulationLayers.slice();
      o.noInsulation = bottomNoInsulation;
      o.emissivity = bottomEmissivity;
      o.cladding = bottomCladding;
    }
  }
  return o;
}

function getSectionDefaultValues(calculatedCreateReturnObject, state, payload, settings) {
  // default input values values

  calculatedCreateReturnObject = {
    ...calculatedCreateReturnObject,
    type: payload.type
  };

  if(payload && payload.type) {
    switch (payload.type) {
      case CALCULATION_TYPE_PLANE:
        calculatedCreateReturnObject = {
          ...calculatedCreateReturnObject,
          width: 1,
          height: 1,
          thickness: 1,
          temperature: 100,
          direction: 'hor',
          position: 'top',
          shape: 'square',
          environmentSolarRadiation: 230,
        };
      break;

      case CALCULATION_TYPE_PIPE:
        calculatedCreateReturnObject = {
          ...calculatedCreateReturnObject,
          length: '',
          outerDiameter: 20,
          thickness: 1,
          temperature: 100,
          flowRate: 0,
          freezingPercentage: 25,
          finalTemperature: 80,
          direction: 'hor',
          environmentSolarRadiation: 230,
          influenceOnHeatloss: '0.01',
          suspensionOfTarget: true
        };
      break;

      case CALCULATION_TYPE_CIRCULAR_DUCT:

        calculatedCreateReturnObject = {
          ...calculatedCreateReturnObject,
          length: 0,
          outerDiameter: 100,
          thickness: 1,
          temperature: 100,
          flowRate: -1,
          direction: 'hor',
          environmentSolarRadiation: 230,
          influenceOnHeatloss: '0.01',
          suspensionOfTarget: true
        };
        break;

      case CALCULATION_TYPE_RECTANGULAR_DUCT:
        calculatedCreateReturnObject = {
          ...calculatedCreateReturnObject,
          influenceOnHeatloss: '0.0035'
        };

        break;

      case CALCULATION_TYPE_VERTICAL_TANK:
        calculatedCreateReturnObject = {
          ...calculatedCreateReturnObject,
          height: 2500,
          thickness: 1,
          outerDiameter: 1500,
          temperature: 100,
          finalTemperature: 80,
          tankBase: 'legs',
          concreteThickness: 300,
          environmentSolarRadiation: 230,
        };
        break;

      case CALCULATION_TYPE_HORIZONTAL_TANK:
        calculatedCreateReturnObject = {
          ...calculatedCreateReturnObject,
          length: 2500,
          thickness: 1,
          outerDiameter: 1500,
          temperature: 100,
          finalTemperature: 80,
          tankBase: 'legs',
          environmentSolarRadiation: 230,
        };
      break;

      case CALCULATION_TYPE_RECTANGULAR_TANK:
        calculatedCreateReturnObject = {
          ...calculatedCreateReturnObject,
          width: 1000,
          height: 1000,
          length: 1000,
          thickness: 1,
          temperature: 100,
          finalTemperature: 80,
          tankBase: 'legs',
          concreteThickness: 300,
          environmentSolarRadiation: 230,
        };
        break;

      default:
    }
  }

  // Environment
  //
  calculatedCreateReturnObject = {
    ...calculatedCreateReturnObject,
    ...getDefaultEnvironment(state, payload)
  };

  //
  // Energy
  calculatedCreateReturnObject = {
    ...calculatedCreateReturnObject,
    ...getDefaultEnergy(state, payload)
  };

  //
  // Material
  calculatedCreateReturnObject = {
    ...calculatedCreateReturnObject,
    ...getDefaultMaterial(state, payload)
  };

  //
  // Content
  calculatedCreateReturnObject = {
    ...calculatedCreateReturnObject,
    ...getDefaultContent(state, payload)
  };

  //
  // Thickness
  calculatedCreateReturnObject = {
    ...calculatedCreateReturnObject,
    thickness: settings ? settings['Default-thickness'] : 1
  };

  // Cladding and Emissity
  calculatedCreateReturnObject = {
    ...calculatedCreateReturnObject,
    ...getDefaultCladding(state, payload)
  };

  // Get default product
  const defaultProduct = getDefaultProduct(state.products, state.settings, state.app.country, payload.type, state.project);
  if(defaultProduct) {
    let product = getItemByNid(defaultProduct.selectedItem, state.products);

    if(payload.type === CALCULATION_TYPE_VERTICAL_TANK ||
      payload.type === CALCULATION_TYPE_HORIZONTAL_TANK ||
      payload.type === CALCULATION_TYPE_RECTANGULAR_TANK ) {
      calculatedCreateReturnObject = {
        ...calculatedCreateReturnObject,
        selectedLayers: CALCULATION_TOP_LAYERS,
        topInsulationLayers: [defaultProduct],
        sideInsulationLayers: [defaultProduct],
        bottomInsulationLayers: [defaultProduct]
      };

      // Set top layers to insulationlayers
      calculatedCreateReturnObject = {
        ...calculatedCreateReturnObject,
        insulationLayers: calculatedCreateReturnObject.topInsulationLayers.slice(),
      };
    } else {
      calculatedCreateReturnObject = {
        ...calculatedCreateReturnObject,
        insulationLayers: [defaultProduct]
      };
    }
    if(product['Support-possible'] === 'true') {
      calculatedCreateReturnObject = {
        ...calculatedCreateReturnObject,
        supportOfCladdingPossible: true
      };
    }
  }

  if(calculatedCreateReturnObject.hasOwnProperty('cladding') && calculatedCreateReturnObject.cladding == -2 && defaultProduct ) {
    const product = getItemByNid(defaultProduct.selectedItem, state.products);
    if(product) {
      calculatedCreateReturnObject = {
        ...calculatedCreateReturnObject,
        emissivity: changeCommaToDot(product['Emissivity']),
        topEmissivity: changeCommaToDot(product['Emissivity']),
        sideEmissivity: changeCommaToDot(product['Emissivity']),
        bottomEmissivity: changeCommaToDot(product['Emissivity']),
      };
    }
  }

  return calculatedCreateReturnObject;
}
function getDefaultValues(calculatedCreateReturnObject, state, payload, settings) {
  // default calculation root values
  //
  // Energy
  calculatedCreateReturnObject = {
    ...calculatedCreateReturnObject,
    ...getDefaultEnergy(state, payload)
  };

  if (payload.type === CALCULATION_TYPE_DUCT) {
    calculatedCreateReturnObject = {
      ...calculatedCreateReturnObject,
      calculateTemperatureChange: true
    };
  }

  return calculatedCreateReturnObject;
}

function checkIfLayersAreValid(state, type) {
  let o = {};

  const c = getCalculation(state.project);
  const s = getSection(c);
  let modifiedInsulationLayers = [];
  if(s && s.insulationLayers && type) {
    for (var i = 0; i < s.insulationLayers.length; i++) {
      const l = s.insulationLayers[i];
      const newTypeProducts = getProductsByType(getProdcutsByLanguage(state.products.data, state.app.country), type);

      // TODO: Check if custom
      let found;
      if(l && newTypeProducts) {
        for (var k = 0; k < newTypeProducts.length; k++) {
          const p = newTypeProducts[k];
          if(l.hasOwnProperty('custom') && l.custom) {
            found = true;
            continue;
          }
          if(p.Nid === l.selectedItem) {
            found = true;
            continue;
          }
        }
        if(found) {
          modifiedInsulationLayers[i] = l;
        } else {
          const defaultProduct = getDefaultProduct(state.products, state.settings, state.app.country, type, state.project);
          modifiedInsulationLayers[i] = defaultProduct;
        }
      }
    }

    if(modifiedInsulationLayers.length) {
      o = {
        ...o,
        insulationLayers: modifiedInsulationLayers
      };
    }
  }
  return o;
}

function checkMaterialStandard(state, materialStandard) {
  let o = {};

  if(materialStandard != '-1') {
    const m = getMaterialStandard(state.materialstandards.data, materialStandard);

    if(m) {
      o = {
        ...o,
        material: m.material,
      };
      switch (m['target-type'].toLowerCase().replace(' ', '-')) {
        case CALCULATION_TYPE_PIPE:
          o = {
            ...o,
            thickness: m.thickness,
            outerDiameter: m.diameter,
          };
          break;
        case CALCULATION_TYPE_CIRCULAR_DUCT:
          o = {
            ...o,
            thickness: m.thickness,
            outerDiameter: m.diameter,
          };
          break;
        case CALCULATION_TYPE_RECTANGULAR_DUCT:
          o = {
            ...o,
            thickness: m.thickness,
            width: m.width,
            height: m.height,
          };
          break;
        default:
      }
    }
  }

  return o;
}

function checkIfStandardIsValid(state, type) {
  let o = {};
  if(type === CALCULATION_TYPE_CIRCULAR_DUCT || type === CALCULATION_TYPE_RECTANGULAR_DUCT) {
    const c = getCalculation(state.project);
    const s = getSection(c);

    const materialStandardsList = state.materialstandards.data.filter( item => {
      if(item['target-type'].toLowerCase().replace(' ', '-') === type && item['material'] == s.material) {
        return true;
      }
      return false;
    });

    if(materialStandardsList && materialStandardsList.length) {
      const materialStandard = s.materialStandard;
      const found = materialStandardsList.find( (item) => {
        return item.Nid === materialStandard;
      });

      if(!found) {
        o = {
          ...o,
          materialStandard: '-1'
        };
      }
    }
  }
  return o;
}

function modifyCalculation(state, payload) {
  if(!payload) {
    return {};
  }

  let calculatedUpdateReturnObject = {
    ...payload
  };
  // If type is changed check if layers are correct
  if(payload.hasOwnProperty('type')) {
    calculatedUpdateReturnObject = {
      ...calculatedUpdateReturnObject,
      ...checkIfLayersAreValid(state, payload.type)
    };

    calculatedUpdateReturnObject = {
      ...calculatedUpdateReturnObject,
      ...checkIfStandardIsValid(state, payload.type)
    };
  }

  // If calculate temperature change is true => freezin is disabled
  if(payload.calculateTemperatureChange) {
    calculatedUpdateReturnObject = {
      ...calculatedUpdateReturnObject,
      calculateFreezing: false
    };
  }

  // No insulation
  if(calculatedUpdateReturnObject.hasOwnProperty('noInsulation')) {
    calculatedUpdateReturnObject = {
      ...calculatedUpdateReturnObject,
      ...updateNoInsulation(state, calculatedUpdateReturnObject),
    };
  }

  // Environment update
  calculatedUpdateReturnObject = {
    ...calculatedUpdateReturnObject,
    ...getUpdatedEnvironment(state, calculatedUpdateReturnObject)
  };

  // Content update
  calculatedUpdateReturnObject = {
    ...calculatedUpdateReturnObject,
    ...getUpdatedContent(state, calculatedUpdateReturnObject)
  };

  // Update correct insulationlayers
  calculatedUpdateReturnObject = {
    ...calculatedUpdateReturnObject,
    ...updateInsulationLayers(state, calculatedUpdateReturnObject)
  };

  // Set correct insulation layers (TANKS)
  calculatedUpdateReturnObject = {
    ...calculatedUpdateReturnObject,
    ...setInsulationLayers(state, calculatedUpdateReturnObject)
  };

  // Update emmissity object, cladding, or product
  calculatedUpdateReturnObject = {
    ...calculatedUpdateReturnObject,
    ...getUpdateEmissivity(state, calculatedUpdateReturnObject)
  };

  // Set cladding and emissivity to correct (TANKS)
  if(payload.hasOwnProperty('cladding') || payload.hasOwnProperty('emissivity') || payload.hasOwnProperty('insulationLayers')) {
    calculatedUpdateReturnObject = {
      ...calculatedUpdateReturnObject,
      ...setCladdingAndEmissivity(state, calculatedUpdateReturnObject)
    };
  }

  // Check if cladding support is possible
  calculatedUpdateReturnObject = {
    ...calculatedUpdateReturnObject,
    ...checkIfSupportOfCladdingIsPossible(state, calculatedUpdateReturnObject)
  };

  // Material standard
  if(payload.hasOwnProperty('materialStandard')) {
    calculatedUpdateReturnObject = {
      ...calculatedUpdateReturnObject,
      ...checkMaterialStandard(state, payload.materialStandard)
    };
  }

  return calculatedUpdateReturnObject;
}

function createNewSectionState(state) {
  const c = getCalculation(state.project);
  const s = getSection(c);

  return {
    ...s
  };
}


export function createMiddleware() {
  return store => next => action => {
    const { type, payload } = action;
    const { settings, app } = store.getState();
    const state = store.getState();

    switch (type) {

      case CALCULATION_LAYER_POSITION:
        next(action);
        store.dispatch(patchCalculationSection(payload));
        break;

      case CALCULATION_ADD_SECTION:
        next(
          {
            ...action,
            payload: createNewSectionState(state)
          }
        );

        // Calculate results
        store.dispatch(calculateResults());
        break;

      case CALCULATION_REMOVE_SECTION:

        /*
        let nextSectionIndex = action.payload.index
        if(nextSectionIndex >= getCalculation(store.getState().project).sections.length - 1){
          nextSectionIndex = getCalculation(store.getState().project).sections.length - 1
        }
        */

        next(action);
        store.dispatch(patchCalculation({}));

        break;

      case CALCULATION_CHANGE_TYPE:
        next(action);

        let calculationType = payload.type;

        if (calculationType === CALCULATION_TYPE_TANK) {
          calculationType = CALCULATION_TYPE_VERTICAL_TANK;
        }

        if(payload && !payload.hasOwnProperty('skipPatchArchiveItem') && !payload.skipPatchArchiveItem) {
            store.dispatch(patchArchiveItem( getCalculation(store.getState().project) ));
        }

        let aiCalculationType = calculationType;
        if(store.getState().project && store.getState().project.hasOwnProperty('useMarineProducts') && store.getState().project.useMarineProducts) {
          aiCalculationType = CALCULATION_TYPE_MARINE + '-' + aiCalculationType;
        }
        const ai = getItemFromArchive( store, getCalculation(store.getState().project).id, aiCalculationType );
        if (ai) {
          adobeClickInsulationObject(getUIText(aiCalculationType, app.language, translations), getUIText(aiCalculationType, 'English', translations), 'select object');
          store.dispatch(updateCalculation( ai ));
        } else {
          if (calculationType === CALCULATION_TYPE_DUCT) {
            calculationType = CALCULATION_TYPE_CIRCULAR_DUCT;
          }
          let defaultSectionValues = getSectionDefaultValues(SECTION_INITIAL_STATE, state, { type: calculationType }, settings);

          const calc = {
            ...payload,
            ...getDefaultValues(INITIAL_STATE, state, payload, settings),
            id: getCalculation(store.getState().project).id,
            name: getCalculation(store.getState().project).name,
            sections: [defaultSectionValues],
          };

          adobeClickInsulationObject(getUIText(calculationType, app.language, translations), getUIText(calculationType, 'English', translations), 'select object');
          store.dispatch(updateCalculation(calc));
          store.dispatch(calculateResults());
        }

        break;

      case CALCULATION_PATCH_SECTION:
      case CALCULATION_PATCH:

        var t0 = performance.now();
// tähän batch circ
        let newPayload = payload;
        if (payload.type) {
          const currentProject = store.getState().project;
          const currentCalculation = currentProject.calculations[currentProject.calculationIndex];
          const currentSection = currentCalculation.sections[currentCalculation.sectionIndex];
          let defaultSectionValues = getSectionDefaultValues(SECTION_INITIAL_STATE, state, { type: payload.type }, settings);

          newPayload = {
            ...newPayload,
            influenceOnHeatloss: defaultSectionValues.influenceOnHeatloss
          };
        }

        next({
          ...action,
          payload: modifyCalculation(state, newPayload)
        });

        var t1 = performance.now();
        // console.log("Call to doSomething took " + (t1 - t0) + " milliseconds.");

        // calculate results
        store.dispatch(calculateResults());

        break;

      case CALCULATION_CREATE:

        //
        // SET DEFAULT values
        // next(action)
        let calculatedCreateReturnObject;
        if(payload.hasOwnProperty('cloned') && payload.cloned) {
          calculatedCreateReturnObject = {
            ...payload
          };
        } else {
          let defaultSectionValues = getSectionDefaultValues(SECTION_INITIAL_STATE, state, { type: payload.type }, settings);

          calculatedCreateReturnObject = {
            ...getDefaultValues(INITIAL_STATE, state, payload, settings),
            ...payload,
            sections: [defaultSectionValues]
          };
        }

        next({
          ...action,
          payload: calculatedCreateReturnObject,
          initialized: app.initialized
        });
        store.dispatch(calculateResults());
        break;

      case CALCULATION_ADD_ADAPTER:
        next(action);
        store.dispatch(patchCalculationSection({}));
        break;

      case CALCULATION_REMOVE_ADAPTER:
        next(action);
        store.dispatch(calculateResults());
        break;

      case CALCULATION_PATCH_ADAPTER:
        next(action);
        store.dispatch(calculateResults());
        break;

      default:
        next(action);
    }
  };
}
